import { Country } from "@commercekit/remix";
import { type Content } from "@prismicio/client";
import { asText } from "@prismicio/helpers";
import type { SliceComponentProps } from "@prismicio/react";
import WvRegisterForm from "~/components/organisms/WvRegisterForm";

/**
 * Props for `BusinessRegistrationForm`.
 */
export type BusinessRegistrationFormProps =
  SliceComponentProps<Content.BusinessRegistrationFormSlice, { phoneCodeCountries: Country[] }>;

/**
 * Component for "BusinessRegistrationForm" Slices.
 */
const BusinessRegistrationForm = ({
  slice,
  context,
}: BusinessRegistrationFormProps): JSX.Element => {
  const phoneCodeCountries = context?.phoneCodeCountries
  return (
    <div className="container mt-6 md-mt-0">
      <div className="row">
        <div className="col-12">
          <WvRegisterForm
            isB2BOnly
            branches={slice.primary.branches?.data?.branches?.map((v) => v.branch)}
            accountRegistrationInfo={slice.primary.account_registration_info?.data?.account_registration_info?.map(
              ({ variation, ...v }) => ({
                primary: v,
                variation,
              })
            )}
            captchaSiteKey={asText(slice.primary.captcha_site_key)}
            phoneCodeCountries={phoneCodeCountries}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessRegistrationForm;
